import type { Theme } from "@mui/material";

// The dark subtleSurfaceBg is lighter than the cards, so the dark page keeps the default background.
export const getArtifactPageBackground = (theme: Theme): string =>
  theme.palette.mode === "light" ? theme.palette.subtleSurfaceBg : theme.palette.background.default;
